import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BigButton, ModalButtonArea } from '../../../common';
import { COMPONENT_LOAD_NAMES } from '../../../constants/constants';
import { useUserContext } from '../../../contexts/UserContext';
import {
  apiGetSharedProductPageListVieEmail,
  assignProductPagePermissionToMember,
} from '../../../helpers/api';
import { handleErrorMessageFromAPIFailer } from '../../../helpers/axiosHelper';
import { getRandomColor } from '../../../helpers/jsHelper';
import { selectAssignEditorPopOpen, selectChooseYourOrgPopOpen, setAssignEditorPopOpen } from '../../../redux/slicers/uiSlicer';
import styles from './AssignEditor.module.scss';
import PaymentDoneIcon from '../../../components/icons/PaymentDone';
import { SHARED_PRODUCT_PAGES_ROUTE_V2 } from '../../../constants/routePathConstants';
import { useNavigate } from 'react-router-dom';
import { resetFilters } from '../../../redux/slicers/admin/sidebarSlicer';
import { PRODUCT_PAGE_SHARE_ACCESS } from '../ShareProductPageModal';
import { AssignEditor } from '../../../common/notifications/NotificationsPanelCard';
import { errorToast } from '../../../helpers/toastHelper';

export const ChooseYourOrg = (props) => {
  const productList = props?.productList || [];
  const enableJoinBtn = props?.productList?.some(({ selected }) => selected);

  const handleAssignEditor = () => {
    const selectedOrg = productList?.filter(({ selected }) => selected);
    window.$selectedOrg = selectedOrg?.map(org => org?.name).join(",")
    props?.handleAssignEditor()
  }
  
  return (
    <div className={styles.chooseYourOrg}>
      <h2>Assign Shared Product Page</h2>
      {/* <div className={styles.subDescription}>
        <p>It looks like you’re signing up with an email from an existing organization.</p>
        <p>Would you like to join one of the organizations below or create a new one?</p>
      </div> */}
      <div className={styles.orgListContainer}>
        {!productList?.length && (
          <div>
            <span>No data available.</span>
          </div>
        )}
        <ul className={styles.orgList}>
          {productList?.map((org, index) => {
            return (
              <>
                <li key={org?.id}>
                  <input
                    type="checkbox"
                    checked={org?.selected}
                    name="inverted1"
                    onChange={() => props?.handleSelectedOrg?.(org?.id)}
                  />

                  {org?.thumbnail ? (
                    <span className={styles.avatar}>
                      <img style={{height:"24px"}} src={org?.thumbnail} alt="tes" />
                    </span>
                  ) : (
                    <span
                      className={styles.avatar}
                      style={{ backgroundColor: org?.bgColor || '#EFAB5D' }}>
                      {org?.name?.trim()?.charAt(0) || 'O'}
                    </span>
                  )}
                  <span>{org?.name}</span>
                </li>
                {index + 1 === productList?.length && props?.loadingMore && (
                  <li>{props?.loadingMore}</li>
                )}
              </>
            );
          })}
        </ul>
      </div>
      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`lf-btn-1 keep-text white-text ${styles.joinBtn}`}
          onClick={()=> handleAssignEditor()}
          disabled={!enableJoinBtn}
          isLoading={props?.submitLoader}
          buttonTitle="Continue"
        />
      </div>
    </div>
  );
};

export const AssignOrCancelOrgRequest = (props) => {
  const navigate = useNavigate()
  const { handleClose } = props || {};

  const handleClickRequestPage = () => {
    navigate(SHARED_PRODUCT_PAGES_ROUTE_V2, { replace: true });
    handleClose?.("refresh",false)
  };
  
  return (
    <div className={styles.RequestSentOrg}>
      <p><PaymentDoneIcon /></p>
      <h2>Product Pages Assigned</h2>
      <div className={styles.subDescription}>
        <p>
          {`Your request for `} <b>{window.$selectedOrg}</b> {` product pages has been approved. You can now view them in the `}
          <a onClick={handleClickRequestPage}>Shared Product Page</a>{` tab.`}
        </p>
      </div>
      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`keep-text ${styles.continueBtn}`}
          onClick={() => handleClose?.("refresh",true)}
          disabled={false}
          buttonTitle="Continue"
        />
      </div>
    </div>
  );
};

export const ManageAssignEditorModel = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { currentUser } = useUserContext();
  const show = useSelector(selectAssignEditorPopOpen);
  const showOrgPick = useSelector(selectChooseYourOrgPopOpen);
  const [open, setOpen] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [productList, setProductList] = useState([]);
  const [assignEditorProductList, setAssignEditorProductList] = useState([]);
  const [nextLink, setNextLink] = useState(null);
  const [search, setSearch] = useState('');
  const loaderRef = useRef(null); // Ref for the loading div

  const [componentLoad, setComponentLoad] = useState([
    {
      name: COMPONENT_LOAD_NAMES.CHOOSE_YOUR_ORG,
      active: false,
      component: ChooseYourOrg,
    },
    {
      name: COMPONENT_LOAD_NAMES.REQUEST_SENT,
      active: false,
      component: AssignOrCancelOrgRequest,
      className: styles.applyBgColor,
    },
    {
      name: COMPONENT_LOAD_NAMES.ASSIGN_EDITOR,
      active: false,
      component: AssignEditor,
      className: styles.applyBgColor,
    }
  ]);

  useEffect(() => {
    if (show && !props?.body) {
      handleGetProductPageList(true);
    }
  }, [show, currentUser?.id]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const componentData = componentLoad?.find(({ active }) => active);
      if (componentData && componentData?.name === COMPONENT_LOAD_NAMES.CHOOSE_YOUR_ORG) {
        handleGetProductPageList(!search, search);
      }
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [search]);

  useEffect(() => {
    // IntersectionObserver to load more data when the loaderRef is visible
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting && nextLink) {
          handleGetProductPageList();
        }
      },
      { threshold: 1.0 }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [nextLink]);

  const handleGetProductPageList = async (isReset, searchVal) => {
    if(!currentUser?.id) return
    const url =
      nextLink && !searchVal
        ? nextLink?.split('?')[1]
        : `per_page=20&page=1&sort=name&search=${search}`;
    const res = await apiGetSharedProductPageListVieEmail(`?${url}`);
    if (res?.results?.length || searchVal) {
      window.$toastMessage = null
      setOpen(true);
      updateComponentLoad(COMPONENT_LOAD_NAMES.CHOOSE_YOUR_ORG, true);
      if (searchVal || isReset) {
        setProductList([...addBgColor(res?.results || [])]);
      } else {
        setProductList((prevList) => [...prevList, ...addBgColor(res?.results || [])]); // Merge new results with current list
      }
      setNextLink(res.next_link);
    } else {
      if(window.$toastMessage){
        errorToast(window.$toastMessage)
        window.$toastMessage = null
      }
      setOpen(false);
      setProductList([]);
      dispatch(setAssignEditorPopOpen(false));
      setNextLink(null);
    }
  };

  const resetStateValue = () => {
    search && setSearch(null);
    nextLink && setNextLink(null);
  };

  const addBgColor = (results) => {
    const data = results?.map((item) => {
      return {
        ...item,
        bgColor: getRandomColor(),
      };
    });
    return data;
  };

  const updateComponentLoad = (name, active) => {
    setComponentLoad((prevState) =>
      prevState.map((item) =>
        item.name === name ? { ...item, active } : { ...item, active: false }
      )
    );
  };

  const isSharedProductPageActive = (fullUrl) => {
    return (window?.location?.pathname === SHARED_PRODUCT_PAGES_ROUTE_V2 || window?.location?.pathname === `${SHARED_PRODUCT_PAGES_ROUTE_V2}/`);
  };

  const handleClose = (isRefresh, isRedirect) => {
    setOpen(false);
    dispatch(setAssignEditorPopOpen(false));
    resetStateValue();
    if(isRedirect && show?.redirectUrl){
      navigate(show?.redirectUrl)  
    }
    if(isRefresh === "refresh" && isSharedProductPageActive()){
      dispatch(resetFilters());
    }
  };

  const handleSelectedOrg = (selectedId) => {
    if (!selectedId) return;
    const cloneOrgList = productList.slice();
    const findIndex = cloneOrgList.findIndex(({ id }) => +id === +selectedId);
    if (~findIndex) {
      cloneOrgList[findIndex]['selected'] = cloneOrgList[findIndex].selected ? false : true;
    }
    setProductList(cloneOrgList);
  };

  const currentComponent = componentLoad?.find(({ active }) => active);
  if (!props.body && (!open || !currentComponent?.component)) {
    return null;
  }

  const handleAssignEditor = async () => {
    const selectedOrg = productList?.filter(({ selected }) => selected);
    if (!selectedOrg?.length) return;
    const isEditType  = selectedOrg?.filter(({ permission_type }) => +permission_type === PRODUCT_PAGE_SHARE_ACCESS.CAN_EDIT);
    if(isEditType?.length){
      setAssignEditorProductList(isEditType || [])
    }
    setSubmitLoader(true);
    try {
      // Make API calls sequentially
      for (const item of selectedOrg) {
        const formData = new FormData();
        formData.append('shared_to_member', currentUser?.id);
        const res = await assignProductPagePermissionToMember({id:+item.id, data:formData});
        if (!res?.status) {
          handleErrorMessageFromAPIFailer(res);
          setSubmitLoader(false);
          return; // Stop if any request fails
        }
      }
       if(isEditType?.length){
        updateComponentLoad(COMPONENT_LOAD_NAMES.ASSIGN_EDITOR, true);
       }else{
        updateComponentLoad(COMPONENT_LOAD_NAMES.REQUEST_SENT, true);
        resetStateValue();
       }
    } catch (error) {
      handleErrorMessageFromAPIFailer(error);
    } finally {
      setSubmitLoader(false);
    }
  };


  const handleAssignEditorMultiple = async (selectedMember) => {
    if (!selectedMember) return;
    setSubmitLoader(true);
    try {
      // Make API calls sequentially
      for (const item of assignEditorProductList) {
        const formData = new FormData();
        formData.append('shared_to_member', selectedMember.id);
        const res = await assignProductPagePermissionToMember({id:item?.id, data:formData});
        const status = res?.status || res?.data?.status
        if (!status) {
          handleErrorMessageFromAPIFailer(res);
          setSubmitLoader(false);
          return; // Stop if any request fails
        }
      }  
      updateComponentLoad(COMPONENT_LOAD_NAMES.REQUEST_SENT, true);
      resetStateValue();
    } catch (error) {
      handleErrorMessageFromAPIFailer(error);
    } finally {
      setSubmitLoader(false);
    }
  };

  const openModal = Boolean((open || props?.body) && !showOrgPick);
  
  return (
    <div
      className={`${styles.registerFlowContainer} ${props?.dialogClassName} ${
        props?.applyBg ? styles.applyBgColor : ''
      } ${currentComponent?.className}`}>
      <ModalButtonArea
        size={props?.size || 'lg'}
        startOpen={openModal}
        showModal={openModal}
        setShowModal={handleClose}
        centered={true}
        className={`${styles.registerFlowContainer} ${props?.dialogClassName} ${
          props?.applyBg ? styles.applyBgColor : ''
        } ${currentComponent?.className}`}
        bigButton={false}
        bigIcon={true}
        variant="link"
        onClose={handleClose}
        closeIconV2
        backdropClassName="overlay-dark"
        headingLeft
        body={
          props?.body ? (
            props.body
          ) : (
            <currentComponent.component
              productList={productList}
              submitLoader={submitLoader}
              handleAssignEditor={handleAssignEditor}
              handleSelectedOrg={handleSelectedOrg}
              handleClose={handleClose}
              assignEditorProductList={assignEditorProductList}
              assignEditorMultipleAPI={handleAssignEditorMultiple}
              assignLoader={submitLoader}
              loadingMore={
                currentComponent.name === COMPONENT_LOAD_NAMES.CHOOSE_YOUR_ORG &&
                nextLink && <div ref={loaderRef}>Loading more...</div>
              }
              onClose={handleClose}
              search={search}
              setSearch={setSearch}
            />
          )
        }
      />
    </div>
  );
};
